import styled from 'styled-components';

import { ContainerProps } from './interface';

export const Content = styled.div<ContainerProps>`
  padding: 0px 0px 0px 340px;
  min-height: ${props => (props.minH ? `${props.minH}px` : '40rem')};
  float: left;
  width: 100%;

  &.menu-closed {
    padding: 0px 0px 0px 50px;
  }

  @media (max-width: 1024px) {
    padding: 60px 0px 0px 0px;
    overflow-x: hidden;

    &.menu-closed {
      padding: 0px 0px 0px 0px;
    }
  }
`;
